const Star = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      d='M7.99994 12.5996L11.4583 14.6913C12.0916 15.0746 12.8666 14.508 12.6999 13.7913L11.7833 9.85797L14.8416 7.20798C15.3999 6.72464 15.0999 5.80798 14.3666 5.74964L10.3416 5.40798L8.7666 1.69131C8.48327 1.01631 7.5166 1.01631 7.23327 1.69131L5.65827 5.39964L1.63327 5.74131C0.899939 5.79964 0.599938 6.71631 1.15827 7.19964L4.2166 9.84964L3.29994 13.783C3.13327 14.4996 3.90827 15.0663 4.5416 14.683L7.99994 12.5996Z'
      fill='#FCC419'
    />
  </svg>
);

export default Star;
